import DataTableManager from './data-table-manager';

export default DataTableManager;
